import ReactDOM from 'react-dom';
import React from 'react';
import ReactPlayer from 'react-player';
 
function VideoPlayer({url}) {
    return <ReactPlayer 
        class="video_player"
        width='100%'
        height='100%'
        url={url}/>
}

const elements = document.getElementsByClassName("video_wrapper");

for (var element of elements ){
    const video_url = element.dataset.url
    ReactDOM.render(<VideoPlayer url={video_url}/>, element);
}